// activeSafetyForms/safetyAuditForm/slice.js

import { activeSafetyAuditFormInitialState } from "./activeSafetyFormsSafetyAuditFormState";
import { makeActiveSafetyAuditFormActions } from "./activeSafetyFormsSafetyAuditFormActions";

export const createActiveSafetyAuditFormSlice = (set, get) => ({
  activeSafetyAuditForm: activeSafetyAuditFormInitialState,
  activeSafetyAuditFormActions: Object.freeze(
    makeActiveSafetyAuditFormActions(set, get)
  ),
});
